const storage = {
    not_configured: '未配置存儲提供程序。',
    missing_parameter: '存儲提供程序缺少參數 {{parameter}}。',
    upload_error: '無法將檔案上傳到存儲提供程序。',
    download_error: '從儲存服務下載檔案失敗。',
};
export default Object.freeze(storage);
